// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const regice: PokeData = {
  "id": 378,
  "name": "regice",
  "height": 18,
  "weight": 1750,
  "base_experience": 261,
  "types": [
    PokeType.ICE
  ],
  "api_moves": [
    "stomp",
    "ice-beam",
    "blizzard",
    "hyper-beam",
    "amnesia",
    "explosion",
    "curse",
    "zap-cannon",
    "icy-wind",
    "lock-on",
    "ancient-power",
    "superpower",
    "hammer-arm",
    "charge-beam",
    "bulldoze"
  ],
  "moves": [
    "blizzard",
    "curse",
    "zap-cannon",
    "ancient-power",
    "superpower",
    "hailstorm",
    "ice-punch",
    "chilly-reception",
    "ice-fang",
    "icicle-dagger",
    "avalanche",
    "aurora-veil",
    "ice-wave"
  ],
  "evolution_chain": {
    "id": 194,
    "item": null,
    "species": [
      {
        "name": "regice",
        "order": 408,
        "types": [
          PokeType.ICE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 174,
    "speed": 75,
    "ability_power": 151
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
